export const leftMenu = {
  profiles: {
    key: "profiles",
    label: "Profiles",
    subs: [
      { key: "profiles-port", label: "Port", showArrow: true },
      { key: "profiles-schedule", label: "Schedule", showArrow: true },
      { key: "profiles-mac-address", label: "MAC Address ", showArrow: true },
      { key: "profiles-ip-address", label: "IP Address ", showArrow: true },
      { key: "profiles-user-account", label: "User Account ", showArrow: true },
      { key: "profiles-radius-server", label: "RADIUS Server ", showArrow: true },
      { key: "profiles-ldap-server", label: "LDAP Server ", showArrow: true },
    ],
    subKey: {
      port: "profiles-port",
      schedule: "profiles-schedule",
      "mac-address": "profiles-mac-address",
      "ip-address": "profiles-ip-address",
      "user-account": "profiles-user-account",
      "radius-server": "profiles-radius-server",
      "ldap-server": "profiles-ldap-server",
    },
    getSubKey: (key) => {
      return leftMenu.profiles.subs.find((sub) => sub.key === key).key;
    },
  },
};
